import type { TAssetFormDTO } from '~/@types/assets'
import type { IPortfolio } from '~/@types/portfolio'
import PortfolioAdapter from '@adapters/PortfolioAdapter'
import PortfolioAssetAdapter from '@adapters/PortfolioAssetAdapter'
import { successToast } from '@helpers/toastHelper'
import { defineStore } from 'pinia'

export const usePortfolioStore = defineStore('portfolio', {
  state: () => {
    return {
      isLoading: false,
      activePortfolio: null as IPortfolio | null,
    }
  },

  actions: {
    async loadDefault(): Promise<void> {
      this.isLoading = true
      this.activePortfolio = await PortfolioAdapter.getDefaultPortfolio()
      this.isLoading = false
    },

    async updateAsset(id: string, data: TAssetFormDTO): Promise<void> {
      await PortfolioAssetAdapter.updateAsset(id, data)
      successToast('Updated')
      await this.loadDefault()
    },

    async deleteAsset(id: string): Promise<void> {
      await PortfolioAssetAdapter.deleteAsset(id)
      successToast('Deleted')
      await this.loadDefault()
    },

    async createAsset(data: TAssetFormDTO): Promise<void> {
      await PortfolioAssetAdapter.createAsset(data)
      successToast('Created')
      await this.loadDefault()
    },
  },
})
